export default {
  // Edge type descriptions
  expandEdge: "This is an expansion edge",
  addressOwnership: "This is address ownership",
  hashNote: "This is a hash note",
  watchAddress: "This is a watch address",
  sameIpAccount: "Same IP account",
  sameDeviceAccount: "Same device account",

  // Transaction information labels
  sender: "Sender",
  receiver: "Receiver",
  transactionHash: "Transaction Hash",
  transactionTime: "Transaction Time",
  transactionQuantity: "Transaction Quantity",
  averageQuantity: "Average Quantity",

  // Labels in comments (reserved for future possible display)
  currencyName: "Currency Name",
  totalQuantity: "Total Quantity",
  totalCount: "Total Count",
  CoinJoin:'CoinJoin Transaction',
};
